module.exports = __webpack_public_path__ + "static/media/img_fenlei18.e67b5ef4.png";